import React from 'react'
import SliderGallery from '../components/SliderGallery'



const CoolstepGallery = () => {


  const galleryImages = [

    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-18.jpg",
      alt:'Dec-Tec membrane in various applications and settings 1'
    },

    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-9.jpg",
      alt:'Dec-Tec membrane in various applications and settings 4'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-8.jpg",
      alt:'Dec-Tec membrane in various applications and settings 5'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-7.jpg",
      alt:'Dec-Tec membrane in various applications and settings 6'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-6.jpg",
      alt:'Dec-Tec membrane in various applications and settings 7'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-5.jpg",
      alt:'Dec-Tec membrane in various applications and settings 8'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-4.jpg",
      alt:'Dec-Tec membrane in various applications and settings 9'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-3.jpg",
      alt:'Dec-Tec membrane in various applications and settings 10'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-1.jpg",
      alt:'Dec-Tec membrane in various applications and settings 11'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-22.jpg",
      alt:'Dec-Tec membrane in various applications and settings 12'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-21.jpg",
      alt:'Dec-Tec membrane in various applications and settings 13'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-19.jpg",
      alt:'Dec-Tec membrane in various applications and settings 14'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-17.jpg",
      alt:'Dec-Tec membrane in various applications and settings 15'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-16.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 16'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-15.jpg",
      alt:'Dec-Tec membrane in various applications and settings 17'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-14.jpg",
      alt:'Dec-Tec membrane in various applications and settings 18'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-13.jpg",
      alt:'Dec-Tec membrane in various applications and settings 19'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-12.jpg",
      alt:'Dec-Tec membrane in various applications and settings 20'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-11.jpg",
      alt:'Dec-Tec membrane in various applications and settings 21'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/CoolStep-10.jpg",
      alt:'Dec-Tec membrane in various applications and settings 22'
    },
    // {
    //   img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_162096402_COOLSTEP-min.jpg",
    //   alt:'Dec-Tec membrane in various applications and settings 23'
    // },
    // {
    //   img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_119844442_COOLSTEP-min.jpg",
    //   alt:'Dec-Tec membrane in various applications and settings 24'
    // },
    // {
    //   img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_119843923_COOLSTEP-min.jpg",
    //   alt:'Dec-Tec membrane in various applications and settings 25'
    // },

  ]

  return (
    <div>
      <SliderGallery
        title="Coolstep"
        para1="A light, neutral pattern, high reflectance, and high traction equals a product perfect to waterproof a rooftop or patio deck located in a warmer climate. Our original CoolStep can bring a lighter, airier feel to your living space."
        galleryImages={galleryImages}
        previouslink="/products/membranes/coolstep-line"
        nextlink="/coolstep-copper-gallery/"
      />
    </div>
  )
}

export default CoolstepGallery
